import { render } from "./KidsView.vue?vue&type=template&id=65c72982&scoped=true"
import script from "./KidsView.vue?vue&type=script&lang=js"
export * from "./KidsView.vue?vue&type=script&lang=js"

import "./KidsView.vue?vue&type=style&index=0&id=65c72982&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c72982"]])

export default __exports__